import { render, staticRenderFns } from "./OtherLayout.vue?vue&type=template&id=7a6489d1&"
import script from "./OtherLayout.vue?vue&type=script&lang=js&"
export * from "./OtherLayout.vue?vue&type=script&lang=js&"
import style0 from "./OtherLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports